<div class="py-4 container-fluid disb-cert-page">
  <h4 class="mb-4 disb-cert-title">ตรวจสอบและอนุมัติเอกสารส่งเบิก</h4>

  <div class="disb-cert-card">
    <div class="disb-cert-card-body">
      <div class="disb-cert-toolbar" [formGroup]="filterForm">
        <div class="disb-cert-filter">
          <app-select
            label="เทอมการศึกษา"
            formControlName="academicTerm"
            [options]="academicTermNameOptions"
            [clearable]="false"
            [searchable]="false"
            classes="mb-0"
          ></app-select>
        </div>

        <div class="disb-cert-filter">
          <app-select
            label="ปีการศึกษา"
            formControlName="academicYear"
            [options]="academicYearOptions"
            [clearable]="false"
            [searchable]="false"
            classes="mb-0"
          ></app-select>
        </div>

        <div class="disb-cert-search">
          <app-filter-search-input
            label="ค้นหา"
            formControlName="keywords"
            ariaLabel="ค้นหาใบรับรองการเบิกจ่าย"
            classes="mb-0"
            (searchSubmit)="onSearch()"
          ></app-filter-search-input>
        </div>
      </div>

      @if (!isRevisionReviewRole) {
        <div class="disb-cert-tabs" role="tablist" aria-label="สถานะใบรับรองการเบิกจ่าย">
          <button
            type="button"
            class="disb-cert-tab"
            [class.active]="activeTab() === 'all'"
            (click)="onTabChange('all')"
          >
            ทั้งหมด
          </button>
          <button
            type="button"
            class="disb-cert-tab"
            [class.active]="activeTab() === 'pending'"
            (click)="onTabChange('pending')"
          >
            รอดำเนินการ
          </button>
        </div>
      } @else {
        <h6 class="disb-cert-review-heading">รายการรอตรวจสอบคำขอแก้ไขตารางสอน</h6>
      }

      <ng-template #statusTemplate let-row="row">
        <span class="disb-cert-status" [ngClass]="statusBadgeClass(row.statusCode)">
          {{ row.statusLabel }}
        </span>
      </ng-template>

      <ng-template #pendingActionTemplate let-row="row">
        <span class="disb-cert-pending-action">{{ pendingActionLabel(row) }}</span>
      </ng-template>

      <ng-template #actionTemplate let-row="row">
        <button
          type="button"
          class="btn disb-cert-action-button datatable-view-action-button"
          aria-label="ดูใบรับรองการเบิกจ่าย"
          (click)="onView(row)"
        >
          <img
            src="assets/media/icons/svg/eye.svg"
            class="disb-cert-action-icon datatable-view-action-icon"
            alt=""
            aria-hidden="true"
          />
        </button>
      </ng-template>

      <app-datatable
        [datasource]="datasource()"
        [columns]="columns"
        [isLoading]="tableLoading()"
        [limit]="10"
        (sortChange)="onSortChange($event)"
      ></app-datatable>

      <app-table-pagination
        [page]="datasource().page"
        [limit]="datasource().limit"
        [total]="datasource().total"
        [totalPage]="datasource().total_page"
        [offset]="datasource().offset"
        [dataLength]="datasource().data.length"
        [pageSizeOptions]="pageSizeOptions"
        ariaLabel="disbursement certification pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
    </div>
  </div>
</div>

@if (detailOpen()) {
  <div class="disb-cert-modal-overlay" role="presentation">
    <div
      class="disb-cert-modal-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="disbCertDetailTitle"
    >
      @if (selectedRow(); as row) {
        <div class="disb-cert-detail-header">
          <div>
            <h5 id="disbCertDetailTitle">{{ row.teacherName }}</h5>
            <span class="disb-cert-status" [ngClass]="statusBadgeClass(row.statusCode)">
              {{ row.statusLabel }}
            </span>
          </div>
          <button type="button" class="btn-close" aria-label="ปิด" (click)="onCloseDetail()"></button>
        </div>

        <div class="disb-cert-detail-body">
          <div class="disb-cert-detail-meta">
            <span>ภาคการศึกษา: {{ row.academicTermLabel }}</span>
            <span>สาขาวิชา: {{ row.departmentName }}</span>
            <span>ภาค: {{ row.pathLabel }}</span>
          </div>

          @if (row.raw.revision_comment) {
            <div class="disb-cert-revision-block">
              <strong>เหตุผลส่งกลับแก้ไขล่าสุด:</strong>
              <p class="disb-cert-revision-comment">{{ row.raw.revision_comment }}</p>
            </div>
          }

          @if (row.raw.compensation_snapshot; as snapshot) {
            <div class="disb-cert-snapshot">
              <h6>สรุปภาระงาน</h6>
              <div class="disb-cert-snapshot-grid">
                <span>ภาระงานขั้นต่ำ: {{ snapshot.minimum_teaching_workload ?? '-' }}</span>
                <span>ภาระงานสอน: {{ snapshot.teaching_workload ?? '-' }}</span>
                <span>ภาระงานสอนรวม: {{ snapshot.total_teaching_workload ?? '-' }}</span>
                <span>ชั่วโมงเกินภาระงาน: {{ snapshot.excess_hours ?? '-' }}</span>
              </div>
            </div>
          }

          <div class="disb-cert-stepper" aria-label="ขั้นตอนการอนุมัติ">
            <h6>ขั้นตอนการอนุมัติ</h6>
            <ol class="disb-cert-stepper-list">
              @for (entry of row.raw.approval_track; track entry.station) {
                <li class="disb-cert-stepper-item" [ngClass]="'disb-cert-stepper-' + entry.state">
                  <span class="disb-cert-stepper-role">{{ entry.role_label }}</span>
                  <span class="disb-cert-stepper-names">{{ stationPersonNames(entry) }}</span>
                  @if (entry.state === 'done' && entry.acted_at) {
                    <span class="disb-cert-stepper-date">ดำเนินการเมื่อ {{ formatDate(entry.acted_at) }}</span>
                  }
                  @if (entry.state === 'current') {
                    <span class="disb-cert-stepper-current-badge">กำลังรอดำเนินการ</span>
                  }
                </li>
              }
            </ol>
          </div>

          <div class="disb-cert-doc-section">
            <h6>เอกสารส่งเบิกที่คำนวณแล้ว</h6>
            @for (docType of calcSectionDocTypes(row); track docType) {
              <div class="disb-cert-doc-row">
                <button
                  type="button"
                  class="disb-cert-doc-row-header"
                  (click)="onTogglePreview(docType)"
                >
                  <span>{{ docLabel(docType) }}</span>
                  <span class="disb-cert-doc-row-toggle">{{ isPreviewExpanded(docType) ? 'ซ่อนตัวอย่าง' : 'ดูตัวอย่าง' }}</span>
                </button>
                @if (isPreviewExpanded(docType)) {
                  <div class="disb-cert-doc-preview">
                    @if (isPreviewLoading(docType)) {
                      <p class="disb-cert-doc-preview-loading">กำลังสร้างตัวอย่างเอกสาร...</p>
                    } @else if (previewHasError(docType)) {
                      <p class="disb-cert-doc-preview-error">ไม่สามารถสร้างตัวอย่างเอกสารได้</p>
                    } @else {
                      @if (previewUrl(docType); as url) {
                        <iframe
                          class="disb-cert-doc-preview-frame"
                          [src]="url"
                          [title]="docLabel(docType)"
                        ></iframe>
                      }
                    }
                  </div>
                }
              </div>
            }
          </div>

          <div class="disb-cert-doc-section">
            <h6>ตารางเรียนตารางสอน</h6>
            @for (docType of scheduleSectionDocTypes(); track docType) {
              <div class="disb-cert-doc-row">
                <button
                  type="button"
                  class="disb-cert-doc-row-header"
                  (click)="onTogglePreview(docType)"
                >
                  <span>{{ docLabel(docType) }}</span>
                  <span class="disb-cert-doc-row-toggle">{{ isPreviewExpanded(docType) ? 'ซ่อนตัวอย่าง' : 'ดูตัวอย่าง' }}</span>
                </button>
                @if (isPreviewExpanded(docType)) {
                  <div class="disb-cert-doc-preview">
                    @if (isPreviewLoading(docType)) {
                      <p class="disb-cert-doc-preview-loading">กำลังสร้างตัวอย่างเอกสาร...</p>
                    } @else if (previewHasError(docType)) {
                      <p class="disb-cert-doc-preview-error">ไม่สามารถสร้างตัวอย่างเอกสารได้</p>
                    } @else {
                      @if (previewUrl(docType); as url) {
                        <iframe
                          class="disb-cert-doc-preview-frame"
                          [src]="url"
                          [title]="docLabel(docType)"
                        ></iframe>
                      }
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>

        <div class="disb-cert-detail-footer">
          @if (revisionWindowLabel(row); as windowLabel) {
            <span class="disb-cert-revision-window">{{ windowLabel }}</span>
          }
          @if (canShowRevisionButton(row)) {
            <button
              type="button"
              class="btn btn-outline-danger"
              [disabled]="!canOpenRevision(row) || actionLoading()"
              [title]="!canOpenRevision(row) ? revisionDisabledTooltip(row) : ''"
              (click)="onOpenRevisionDialog()"
            >
              {{ revisionButtonLabel() }}
            </button>
          }
          @if (canActPrimary(row)) {
            <button
              type="button"
              class="btn btn-primary"
              [disabled]="actionLoading()"
              (click)="onOpenPrimaryConfirm()"
            >
              {{ primaryActionButtonLabel(row) }}
            </button>
          }
        </div>
      }
    </div>
  </div>
}

<app-confirm-dialog
  #primaryConfirmDialog
  modalId="disbursementCertificationPrimaryConfirmDialog"
  icon="success"
  [title]="primaryActionDialogTitle()"
  [message]="primaryActionDialogMessage()"
  cancelText="ยกเลิก"
  [confirmText]="primaryActionDialogConfirmText()"
  [isProcessing]="actionLoading()"
  [stackAboveModal]="true"
  (confirmed)="onConfirmPrimaryAction()"
></app-confirm-dialog>

<app-disbursement-revision-dialog
  #revisionDialog
  modalId="disbursementCertificationRevisionDialog"
  [title]="revisionDialogTitle()"
  [confirmText]="revisionDialogConfirmText()"
  [isProcessing]="actionLoading()"
  [stackAboveModal]="true"
  (submitted)="onRevisionSubmitted($event)"
  (cancelled)="onRevisionCancelled()"
></app-disbursement-revision-dialog>
